import {
  spacing3,
  spacing5,
  Typography,
} from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useStorefrontState } from '../../../../../../hooks/useReduxState';
import {
  addTimedBanner,
  setLocationFromHeader,
} from '../../../../../../store/actions/storefrontActions';
import {
  HeaderMobileNavPanelActions,
  HeaderMobileNavPanelContainer,
} from '../HeaderMobileNavPanel.styles';

const HeaderMobileNavPanelAccount = ({
  closeAllPanels,
  setIsMobileNavOpen,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authUser, cart, navigation, shopper, vendor } = useStorefrontState();
  const { dispensaries, vendors } = authUser;
  const { selectedCart } = cart;
  const { currentLocation, dispensary } = shopper;
  const { links } = navigation;
  const { slug } = vendor;

  return (
    <HeaderMobileNavPanelContainer data-testid='header-mobile-nav-panel-account--component--div'>
      <Typography
        classes={['h7']}
        component='span'
        sx={{
          padding: `${spacing5} ${spacing5} ${spacing3}`,
          margin: 0,
          textTransform: 'capitalize',
        }}
      >
        Account
      </Typography>
      <HeaderMobileNavPanelActions>
        {links.map((link) => (
          <a href={link.href} key={link.href}>
            {link.text}
          </a>
        ))}
      </HeaderMobileNavPanelActions>
      <Typography
        classes={['h7']}
        component='span'
        sx={{
          padding: `${spacing5} ${spacing5} ${spacing3}`,
          margin: 0,
          textTransform: 'capitalize',
        }}
      >
        Vendor Accounts
      </Typography>
      <HeaderMobileNavPanelActions>
        {vendors.map((vendor) => (
          <a
            key={vendor.id}
            href={`/dashboard/vendor/${vendor.id}`}
            onClick={() => {
              closeAllPanels();
              setIsMobileNavOpen(false);
            }}
          >
            <Typography component='span'>{vendor.name}</Typography>
          </a>
        ))}
      </HeaderMobileNavPanelActions>
      <Typography
        classes={['h7']}
        component='span'
        sx={{
          padding: `${spacing5} ${spacing5} ${spacing3}`,
          margin: 0,
          textTransform: 'capitalize',
        }}
      >
        Customer Accounts
      </Typography>
      <HeaderMobileNavPanelActions>
        {dispensaries.map((dispo) => (
          <button
            key={dispo.id}
            type='button'
            onClick={async () => {
              if (dispo.id === dispensary.id) return;
              dispatch(
                setLocationFromHeader({
                  dispensaryId: dispo.id,
                  vendorSlug: slug || null,
                })
              );
              if (selectedCart.quantity && selectedCart.quantity > 0) {
                await dispatch(
                  addTimedBanner({
                    id: `${dispensary.name}-${currentLocation.name}-cart-saved`,
                    message: `Your cart for ${dispensary.name} at ${currentLocation.name} has been saved`,
                    severity: 'success',
                  })
                );
              }
              await navigate(`/storefront/`);
              closeAllPanels();
              setIsMobileNavOpen(false);
            }}
          >
            <Typography component='span'>{dispo.name}</Typography>
          </button>
        ))}
      </HeaderMobileNavPanelActions>
    </HeaderMobileNavPanelContainer>
  );
};

HeaderMobileNavPanelAccount.propTypes = {
  closeAllPanels: PropTypes.func.isRequired,
  setIsMobileNavOpen: PropTypes.func.isRequired,
};

export default HeaderMobileNavPanelAccount;
